import Header from "../header";
import axios from "axios";
import { apiCall_domain } from "../api";
import React, { Component } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { toast } from "react-hot-toast";

var foo;
class AddTicket extends Component {
  state = {
    selectImage: null,
    textAreaValue: null,
    inputValue: null,
    secInputValue: null,
    loader: false,
    imageUrl: null,
    uploadedImages: [],
    error: "",
    sendTicket: "",
    loading: false,
    vendorId: "",
    vendorItemId: "",
    storeName: "",
  };
  chooseVendor = (vendorItemId, vendorId, storeName) => {
    this.setState({
      vendorId: vendorId,
      vendorItemId: vendorItemId,
      storeName: storeName,
    });
  };
  getFilterValue = (vendorId) => {
    const value = this.props.vendors.find(
      (vendor) => vendor.vendor_id === vendorId,
    );
    return value || "";
  };
  render() {
    const imageUploadChanges = (e, id, name) => {
      this.setState({ selectImage: e.target.files[0] });
    };
    const ReturnPic = () => {
      var binaryData = [this.state.selectImage];
      foo = URL.createObjectURL(new Blob(binaryData, { type: "image/png" }));
      return <img className="UploadedImgCertificate" src={foo} alt="pic" />;
    };
    const texrAreaChanges = (event) => {
      this.setState({ textAreaValue: event.target.value });
    };

    const inputChanges = (event) => {
      this.setState({ inputValue: event.target.value });
    };

    const uploadFile = (file) => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
      };
      const formData = new FormData();
      formData.append("file", file);
      return axios.post(`${apiCall_domain}/customer/store-file`, formData, {
        headers: headers,
      });
    };
    const uploadImage = async () => {
      return new Promise((resolve, reject) => {
        uploadFile(this.state.selectImage).then((res) => {
          this.setState({ uploadedImages: res.data.name });
          resolve();
        });
      });
    };
    const sendTicket = () => {
      if (this.state.inputValue === null) {
        this.setState({ error: "لطفا فیلد عنوان را کامل کنید" });
      } else if (this.state.textAreaValue === null) {
        this.setState({ error: "لطفا سوال خود را شرح دهید" });
      } else if (this.state.selectImage) {
        this.setState({ loading: true });
        uploadImage().then((res) => {
          const data = {
            title: this.state.inputValue,
            text: this.state.textAreaValue,
            pic: this.state.uploadedImages,
            item_vendor_id: this.state.vendorItemId,
            vendor_id: this.state.vendorId,
          };
          const headers = {
            Authorization: localStorage.getItem("Api_key"),
            "content-type": "application/json",
          };
          axios
            .post(`${apiCall_domain}/customer/user/tickets`, data, {
              headers,
            })
            .then((res) => {
              this.setState(
                { sendTicket: res.data.message, loading: false },
                () => {
                  localStorage.setItem("sendTicket", 1);
                },
              );
              toast.success("تیکت ارسال شد");
              this.props.addTicket();
            });
        });
      } else {
        this.setState({ loading: true });

        const data = {
          title: this.state.inputValue,
          text: this.state.textAreaValue,
        };
        const headers = {
          Authorization: localStorage.getItem("Api_key"),
          "content-type": "application/json",
        };
        axios
          .post(`${apiCall_domain}/customer/user/tickets`, data, {
            headers,
          })
          .then((res) => {
            this.setState(
              { sendTicket: res.data.message, loading: false },
              () => {
                localStorage.setItem("sendTicket", 1);
              },
            );
            toast.success("تیکت ارسال شد");
            this.props.addTicket();
          });
      }
    };

    return (
      <>
        <Header
          showSearchBar={true}
          title={"ایجاد تیکت جدید"}
          backHandler={() => {
            this.props.addTicket();
          }}
        />

        <div className="TicketMain">
          <div className="innerTicketMain">
            <Box sx={{ width: "100%", marginY: "1rem", minWidth: "100%" }}>
              <FormControl sx={{ width: "100%", minWidth: "100%" }}>
                <Select
                  inputProps={{ "aria-label": "Without label" }}
                  name="vendor"
                  value={this.getFilterValue(this.state.vendorId)}
                  onChange={(e) =>
                    this.chooseVendor(
                      e.target.value.vendor_item_id,
                      e.target.value.vendor_id,
                      e.target.value.store_name,
                    )
                  }
                  displayEmpty
                >
                  <MenuItem value="">انتخاب فروشنده </MenuItem>

                  {this.props.vendors.map((item, index) => (
                    <MenuItem value={item} key={index}>
                      {item.store_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <div className="inputsRow inputsRowFirst">
              <input
                type="text"
                placeholder="عنوان سوال یا مشکل"
                className="ticketInput"
                onChange={(e) => inputChanges(e)}
              />
            </div>
            <div className="inputsRow textAreaRow">
              <textarea
                type="text"
                placeholder=" سوال یا مشکل خود را بطور کامل شرح دهید..."
                className="ticketInput"
                onChange={(e) => texrAreaChanges(e)}
              />
            </div>
            <div className="fileUpload">
              <div className="mainUpload">
                <input
                  type="file"
                  onChange={(e) => imageUploadChanges(e, 1, "1عکس")}
                  onClick={() => this.setState({ loader: true })}
                />
              </div>
              <div className="fileUploadP">
                {!this.state.selectImage ? (
                  <span>افزودن تصویر</span>
                ) : (
                  ReturnPic(1)
                )}
              </div>
            </div>
          </div>
          <div className="error">{this.state.error}</div>
          <div className="successfulTicket">{this.state.sendTicket}</div>
          <div className="ticketButton">
            <button
              className="mainTicketButton"
              type="submit"
              onClick={() => sendTicket()}
            >
              {this.state.loading ? (
                <PulseLoader color={"white"} />
              ) : (
                "ارسال تیکت"
              )}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default AddTicket;
